import React from 'react';
import { Link } from 'react-router-dom';
import { pathJoin } from '../../../../services/api';
import { useHasPermission } from '../../../../services/auth/auth';
import { Add, Delete, Edit } from '../../../shared/actions/actionButtons';
import { QueryGrid } from '../../../shared/grid/queryGrid/queryGrid';
import { Telephone } from '../../../shared/links/telephone';
import { BRANCH, USER } from '../../../../permissions';

import styles from './branchList.module.css';

export const BranchList = (props) => {

    const canReadUser = useHasPermission(USER.READ);

    return <QueryGrid
        queryParamPrefix=''
        singleResourceName='Branch'
        pluralResourceName='Branches'
        nameFunction={r => r.name}
        restEndpoint='/locations/branches'
        listUrl='/locations/branches'
        actions={[Add, Edit, Delete]}
        readPermissions={[BRANCH.READ]}
        writePermissions={[BRANCH.WRITE]}
        columns={{
            name: {
                label: 'Name',
                passOnClick: true,
                formatFunction: r => <Link to={pathJoin('/locations/branches', r.id)}>{r.name}</Link>,
            },
            zipcodeCount: {
                label: 'Zip Codes',
                formatFunction: r => r.zipcodeCount,
            },
            'manager.displayName': {
                label: 'Manager',
                formatFunction: r => (canReadUser && r.manager?.id) ? <Link to={pathJoin('/users/' + r.manager?.id)}>{r.manager?.displayName}</Link> : r.manager?.displayName,
            },
            phone: {
                label: 'Branch Phone',
                formatFunction: r => <Telephone number={r.phone} />,
            }
        }}
        {...props}
    />
}